import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
// import ScheduledPostActionPopup from "./PostGridActionPopup.component";
import { DoneAll } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import HttpServices from 'src/services/httpService';
import { imageModeuleUrl, postsModuleURL, userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import RejectedApprovalGridActionPopup from './rejected-post-grid-action-popup.component';

const RejectedApprovalGridAction = ({ rejectedPost, handleReCallRejectedApprovalPost, isOrgEvent }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { showToast } = useToaster();
  const [selectedPopOverPost, setPopOverPost] = useState(null);
  const [popoverElement, setPopoverElement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmationDialogue, setConfirmationDialogue] = useState(null);
  const handleOpenMenu = (event, rejectedPost) => {
    setPopOverPost(rejectedPost);
    setPopoverElement(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setPopOverPost(null);
    setPopoverElement(null);
  };

  const closeConfirmationDialogue = () => {
    setConfirmationDialogue(null);
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    handleCloseMenu();
    closeConfirmationDialogue();
    setLoading(false);
  };

  const fetchMediaMetaData = (data, editAsNew = false) => {
    let mediaBody = {
      media_urls: data?.media_url.split(','),
    };
    let postProps = {
      url: imageModeuleUrl.fetchMediaMetadata,
      body: mediaBody,
      successCallback: (imageData, message) => {
        fetchMediaSuccessCallback(imageData, message, data, editAsNew);
      },
      failureCallback: failureCallback,
    };
    HttpServices.Post(postProps);
  };
  const fetchMediaSuccessCallback = (imageData, mesaage, data, editAsNew) => {
    if (editAsNew) {
      uploadEditDataToNewPost(data, imageData ? imageData.media_datas : []);
    } else {
      uploadDataToPost(data, imageData ? imageData.media_datas : []);
    }
  };
  const newPostSucessCallback = (data) => {
    if (data.media_url && data.media_url.length > 0) fetchMediaMetaData(data);
    else uploadDataToPost(data);
  };

  const editNewPostSucessCallback = (data) => {
    let editAsNew = true;
    if (data.media_url && data.media_url.length > 0) fetchMediaMetaData(data, editAsNew);
    else uploadEditDataToNewPost(data);
  };

  const uploadDataToPost = (data, imageData = []) => {
    setLoading(false);
    const updatedData = {
      ...data,
      media_data: imageData,
      schedule_id: rejectedPost?.id,
    };
    const newPostData = CommonHelper.CommonNewPostAddMediaAllService(updatedData, imageData);
    navigate('/new-post', { state: { data: newPostData } });
  };
  const uploadEditDataToNewPost = (data, imageData = []) => {
    setLoading(false);
    const newPostData = CommonHelper.CommonNewPostAddMediaAllService(data, imageData);
    navigate('/new-post', { state: { data: newPostData } });
  };
  const handleEditPost = () => {
    setLoading(true);
    CommonHelper.CommonNewPostStruct(isOrgEvent, rejectedPost.id, newPostSucessCallback, failureCallback);
  };
  const handleEditAsNewPost = () => {
    setLoading(true);
    CommonHelper.CommonNewPostStruct(isOrgEvent, rejectedPost.id, editNewPostSucessCallback, failureCallback);
  };

  const handleDeletePost = () => {
    handleCloseMenu();
    setConfirmationDialogue({
      isOpen: true,
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this Schedule?',
      submitFunction: confirmDeletePost,
    });
  };

  const confirmDeletePost = () => {
    let postProps = {
      url: isOrgEvent
        ? postsModuleURL.deleteOrgSchedule + rejectedPost.id
        : postsModuleURL.deleteSchedule + rejectedPost.id,
      successCallback: deleteSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
    closeConfirmationDialogue();
  };

  const deleteSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallRejectedApprovalPost();
  };

  const handleApprovePost = () => {
    handleCloseMenu();
    setConfirmationDialogue({
      isOpen: true,
      title: 'Confirm Post Now',
      message: 'Are you sure you want to Approve this Schedule?',
      submitFunction: confirmApprovePost,
    });
  };

  const confirmApprovePost = () => {
    let props = {
      schedule_id: rejectedPost.id,
    };
    let postProps = {
      url: isOrgEvent ? userModuleURL.orgApprovePost : userModuleURL.approvePost,
      body: props,
      successCallback: approvePostSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const approvePostSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
    closeConfirmationDialogue();
    handleReCallRejectedApprovalPost();
  };

  const handleSaveAsDraft = () => {
    let props = {
      schedule_post_id: rejectedPost.id,
    };
    let postProps = {
      url: isOrgEvent ? postsModuleURL.orgSavePostAsDraft : postsModuleURL.savePostAsDraft,
      body: props,
      successCallback: saveAsDraftSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const saveAsDraftSuccessCallback = (data, message) => {
    message && showToast(message);
    handleCloseMenu();
  };

  const postActionProps = {
    popoverElement: popoverElement,
    popoverElement,
    handleCloseMenu,
    rejectedPost: rejectedPost,
    approvePost: handleApprovePost,
    editAsNewPost: handleEditAsNewPost,
    editPost: handleEditPost,
    saveAsDraft: handleSaveAsDraft,
    deletePost: handleDeletePost,
    loading,
    selectedPopOverPost: selectedPopOverPost,
  };

  return (
    <>
      <Box alignItems="center">
        {rejectedPost.has_approve_access && (
          <Tooltip title="Approve Post">
            <IconButton
              size="large"
              color="inherit"
              sx={{
                padding: '2px',
                marginRight: '2px',
                color: theme.palette.primary.main, // Use the primary color from the theme
              }}
              onClick={(e) => {
                handleApprovePost(e, rejectedPost);
              }}
            >
              <DoneAll />
            </IconButton>
          </Tooltip>
        )}
        <IconButton
          size="large"
          color="inherit"
          onClick={(e) => {
            handleOpenMenu(e, rejectedPost);
          }}
          sx={{ padding: '6px', marginRight: '2px' }}
        >
          <MoreVertIcon />
        </IconButton>
      </Box>
      <RejectedApprovalGridActionPopup {...postActionProps} />
      {confirmationDialogue && (
        <ConfirmationDialog
          open={confirmationDialogue.isOpen}
          onClose={() => closeConfirmationDialogue()}
          onConfirm={confirmationDialogue.submitFunction}
          title={confirmationDialogue.title}
          message={confirmationDialogue.message}
        />
      )}
    </>
  );
};

export default RejectedApprovalGridAction;
